import React from "react";
import { Footer, Header } from "../Home/components";
import {
  Body,
  BodyDescription,
  MiddleBody,
  Brands,
  GetinTouch,
} from "./components";
export default function View() {
  return (
    <div>
      <Header page="contact" />
      <Body />
      <BodyDescription />
      <MiddleBody />
      <Brands />
      <GetinTouch />
      <Footer page="contact" />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/pages/ContactUs/view.jsx